import styled from 'styled-components'
import { FONT_SIZE } from '../../themes'

export const BookingDetailStyled = styled.div`
  height: 100%;

  .booking-detail__top-bar {
    height: 30px;
    padding: 18px 24px;
    display: flex;
    align-items: center;

    &__project-name {
      display: flex;
      align-items: center;
      gap: 20px;

      button {
        display: flex;
        align-items: center;
        background: none;
        border: 0;
      }
    }
    
    &__back-button {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }

    p {
      margin: 0;
      font-family: LibreBaskervilleBold;
      font-size: ${FONT_SIZE.MD};
    }
  }

  .booking-detail__box {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
`
